import { isAxiosError } from 'axios';

export interface StickerOrderItem {
  id: string;
  label: string;
  thumbnailUrl?: string | null;
  status: string;
}

export function moveStickerOrderItem(
  items: StickerOrderItem[],
  id: string,
  position: number,
): StickerOrderItem[] {
  const from = items.findIndex((item) => item.id === id);
  if (from < 0 || !Number.isInteger(position) || position < 0 || position >= items.length)
    return items;
  const next = [...items];
  const [item] = next.splice(from, 1);
  if (!item) return items;
  next.splice(position, 0, item);
  return next;
}

export function stickerMutationError(error: unknown): string {
  if (isAxiosError(error)) {
    const body: unknown = error.response?.data;
    if (body && typeof body === 'object' && 'message' in body && typeof body.message === 'string')
      return body.message;
  }
  return error instanceof Error
    ? error.message
    : 'Could not save changes. Reload the library and try again.';
}
